import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, AlertCircleIcon, Loader2Icon } from 'lucide-react';
type Status = 'idle' | 'sending' | 'success' | 'error';
const MOTIVOS = ['Terapia Individual', 'Terapia de Pareja', 'Talleres de Mindfulness', 'Orientación para Padres', 'Otra consulta'];
const inputClass = 'w-full rounded-2xl bg-crema px-5 py-3.5 text-dark placeholder:text-medium/60 shadow-[inset_4px_4px_8px_#e3ded6,inset_-4px_-4px_8px_#ffffff] outline-none transition-shadow duration-200 focus:shadow-[inset_2px_2px_6px_#e3ded6,inset_-2px_-2px_6px_#ffffff,0_0_0_2px_rgba(122,158,126,0.45)]';
export function Contact() {
  const [status, setStatus] = useState<Status>('idle');
  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = event.currentTarget;
    const data = Object.fromEntries(new FormData(form).entries());
    setStatus('sending');
    try {
      const response = await fetch('https://formsubmit.co/ajax/nayibemarketing@gmail.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          ...data,
          _subject: 'Nueva consulta desde la web',
          _template: 'table'
        })
      });
      if (!response.ok) throw new Error('Error de envío');
      form.reset();
      setStatus('success');
    } catch {
      setStatus('error');
    }
  }
  return <section id="contacto" className="py-24 px-6 lg:px-12" data-id="element-27" data-mp="2s4eydy158ou0">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-[0.85fr_1fr] gap-12 lg:gap-16 items-center" data-id="element-28" data-mp="2s683va00t30f">
        <motion.div className="space-y-6" initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-29" data-mp="2w835kflv5ieq">
          <h2 className="text-4xl md:text-5xl font-serif text-dark leading-tight" data-id="element-30" data-mp="23cdhrhe9hklg">
            Escribime y damos <span className="text-eucalipto" data-id="element-31" data-mp="1yaxt7fcvkvyb">el primer paso</span>
          </h2>
          <p className="text-medium text-lg leading-relaxed max-w-md" data-id="element-32" data-mp="1ubxea7xiqdgl">
            Contame brevemente qué te está pasando y qué estás buscando. Te
            respondo personalmente por correo dentro de las 48 horas hábiles.
          </p>
          <p className="text-medium/80 text-sm leading-relaxed max-w-md" data-id="element-33" data-mp="2m46791u4gnof">
            Todo lo que compartas es confidencial. Si preferís una respuesta más
            rápida, también podés escribirme por WhatsApp.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-crema-light rounded-[2.5rem] p-8 md:p-10 shadow-neumorph" data-id="element-34" data-mp="28bgm0zmf3msd">
          {status === 'success' ? <div role="status" className="flex flex-col items-center text-center gap-4 py-10" data-id="element-35" data-mp="3d9k7muxnq7ge">
              <CheckCircle2Icon className="w-14 h-14 text-eucalipto" data-id="element-36" data-mp="3i7lpxdn9e2qt" />
              <h3 className="text-2xl font-serif text-dark" data-id="element-37" data-mp="3ma09jzyr56j5">
                Tu mensaje fue enviado
              </h3>
              <p className="text-medium max-w-sm leading-relaxed" data-id="element-38" data-mp="3ra4r7tbec7ay">
                Gracias por confiar. Te voy a responder por correo a la brevedad.
              </p>
              <button type="button" onClick={() => setStatus('idle')} className="mt-2 text-terracota font-medium underline underline-offset-4 transition-colors duration-200 hover:text-terracota-hover" data-id="element-39" data-mp="4ts4mcw5tzud">
                Enviar otro mensaje
              </button>
            </div> : <form onSubmit={handleSubmit} className="space-y-5" noValidate={false} data-id="element-40" data-mp="iub774huwdp5">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-41" data-mp="55rekab64pxo">
                <div className="space-y-2" data-id="element-42" data-mp="15h5upvzrlf4">
                  <label htmlFor="nombre" className="block text-sm font-medium text-dark" data-id="element-43" data-mp="14pnwhvbhm7b">
                    Nombre
                  </label>
                  <input id="nombre" name="Nombre" type="text" required autoComplete="name" placeholder="Tu nombre" className={inputClass} data-id="element-44" data-mp="9xj9ex1cxhtm" />
                </div>
                <div className="space-y-2" data-id="element-45" data-mp="3sc1xaapykvco">
                  <label htmlFor="telefono" className="block text-sm font-medium text-dark" data-id="element-46" data-mp="3sctt9mngwv3h">
                    Teléfono <span className="text-medium font-normal" data-id="element-47" data-mp="3nb4go2klk9da">(opcional)</span>
                  </label>
                  <input id="telefono" name="Teléfono" type="tel" autoComplete="tel" placeholder="+54 9 299 ..." className={inputClass} data-id="element-48" data-mp="17ne3muzzjcff" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-49" data-mp="2bj533jsqdwk6">
                <label htmlFor="email" className="block text-sm font-medium text-dark" data-id="element-50" data-mp="2bk6pulj407hq">
                  Correo electrónico
                </label>
                <input id="email" name="Email" type="email" required autoComplete="email" placeholder="tunombre@correo.com" className={inputClass} data-id="element-51" data-mp="2gk2t2ijzfuw8" />
              </div>

              <div className="space-y-2" data-id="element-52" data-mp="2zh3z86p9w11r">
                <label htmlFor="motivo" className="block text-sm font-medium text-dark" data-id="element-53" data-mp="2zfsy6en7p7ec">
                  Motivo de consulta
                </label>
                <select id="motivo" name="Motivo" className={inputClass} defaultValue={MOTIVOS[0]} data-id="element-54" data-mp="3rxepw9hbrd8w">
                  {MOTIVOS.map(motivo => <option key={motivo} value={motivo} data-id="element-55" data-mp="5mogdzfb652m">
                      {motivo}
                    </option>)}
                </select>
              </div>

              <div className="space-y-2" data-id="element-56" data-mp="3ruejk2sjgy8o">
                <label htmlFor="mensaje" className="block text-sm font-medium text-dark" data-id="element-57" data-mp="3rtczx9xgj3fc">
                  Tu mensaje
                </label>
                <textarea id="mensaje" name="Mensaje" rows={5} required placeholder="Contame en pocas líneas qué te gustaría trabajar..." className={`${inputClass} resize-none`} data-id="element-58" data-mp="3iv1ahb8buboh" />
              </div>

              {status === 'error' && <div role="alert" className="flex items-start gap-3 rounded-2xl bg-terracota/10 px-4 py-3 text-sm text-terracota-hover" data-id="element-59" data-mp="343io8vovjkwo">
                  <AlertCircleIcon className="w-5 h-5 flex-shrink-0 mt-0.5" data-id="element-60" data-mp="2v71kidiuapay" />
                  <p data-id="element-61" data-mp="1am4lly0avdfy">
                    No pudimos enviar tu mensaje. Volvé a intentarlo o escribinos
                    por WhatsApp.
                  </p>
                </div>}

              <motion.button type="submit" disabled={status === 'sending'} whileHover={status === 'sending' ? undefined : {
            scale: 1.02
          }} whileTap={status === 'sending' ? undefined : {
            scale: 0.98
          }} transition={{
            duration: 0.16,
            ease: [0.23, 1, 0.32, 1]
          }} className="w-full flex items-center justify-center gap-2 bg-terracota text-white px-8 py-4 rounded-full font-medium tracking-wide shadow-lg transition-colors duration-200 hover:bg-terracota-hover disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-62" data-mp="1jovwnwp9k772">
                {status === 'sending' ? <>
                    <Loader2Icon className="w-5 h-5 animate-spin" data-id="element-63" data-mp="d6gwsebxf7qx" />
                    Enviando...
                  </> : 'Enviar mensaje'}
              </motion.button>

              <p className="text-center text-xs text-medium/80" data-id="element-64" data-mp="2xs25oj2jw7fj">
                Tus datos se envían de forma privada y no se comparten con terceros.
              </p>
            </form>}
        </motion.div>
      </div>
    </section>;
}